module.exports = __webpack_public_path__ + "static/media/6.05ac5462.jpg";